export const AGREEMENT_CUSTOMER = 'AGREEMENT_CUSTOMER';
export const AGREEMENT_CUSTOMER_CARD_PAYMENT = 'AGREEMENT_CUSTOMER_CARD_PAYMENT';
export const AGREEMENT_CASH_CUSTOMER = 'AGREEMENT_CASH_CUSTOMER';
export const ANONYMOUS_CUSTOMER = 'ANONYMOUS_CUSTOMER';
export const AGREEMENT_SUPPLIER = 'AGREEMENT_SUPPLIER';
